import styled from "@emotion/styled";
import { Alert, Button, Col, Form, Modal, Row, Typography, message } from "antd";
import { FC, useState } from "react";
import { useCreateRetailBankType, useDeleteRetailBankType, useGetRetailBankTypeList } from "hooks/useFactory";
import { PlusOutlined } from "@ant-design/icons";
import { createRetailBankTypeInput } from "services/interface";
import TypeConfigForm from "./CreateTypeConfigs/TypeConfigForm";
import TypeItemsCard from "./TypeItemsCard";

interface MainCreateBankingRetailProps {
  retailId: string
}

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 },
  },
};

const MainCreateBankingRetail: FC<MainCreateBankingRetailProps> = ({ retailId }) => {
  const [open, setOpen] = useState(false);
  // const { data: transportConfigsData, refetch: refetchTransportConfigs } = useGetTransportationConfigsByAgentId(agentId);
  const { mutate: CreateRetailBankType } = useCreateRetailBankType();
  const { mutate: DeleteRetailBankType } = useDeleteRetailBankType();
  // const { data: agentBankData, refetch: refetchBank } =  useGetAgentBankList(agentId ?? '');
  const { data: retailBankTypeData, refetch: refetchBankType } =  useGetRetailBankTypeList(retailId ?? '');

  
  const [form] = Form.useForm();
  const showDrawer = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  const onDeleteData = (id: string) => {
    DeleteRetailBankType({
      retail_id: retailId,
      bank_type_id: id
    }, {
      onSuccess: (res) => {
        if (res.status === "success") {
          message.success("ลบสำเร็จ");
          // refetchBank();
          refetchBankType();
        } else {
          message.error(`ลบไม่สำเร็จ: ${res.error_message}`);
        }
      },
      onError: (error) => {
        message.error(`ลบไม่สำเร็จ: ${error.message}`);
      },
    });
  }

  const onFinish = (values: any) => {
    const dataRaw:createRetailBankTypeInput = {
      retail_id: retailId,
      bank_type_id: values.bank_type_id,
    }
    CreateRetailBankType(dataRaw,
      {
        onSuccess: (data) => {
          if (data.status === "success") {
            message.success("เพิ่มสำเร็จ");
            onClose();
            refetchBankType();
            // refetchBank();
            form.resetFields();
          }else {
            message.error(`เพิ่มไม่สำเร็จ ${data.error_message}`);
          }
        },
        onError: () => {
          message.error("เพิ่มไม่สำเร็จ");
        },
      }
    );
  }

  // const onFinish = (values: any) => {
  //   const dataRaw:createAgentBankInput = {
  //     agent_id: agentId,
  //     bank_id: values.bank_id,
  //   }
  //   CreateAgentBank(dataRaw,
  //     {
  //       onSuccess: (data) => {
  //         if (data.status === "success") {
  //           message.success("เพิ่มสำเร็จ");
  //           onClose();
  //           refetchBank();
  //           form.resetFields();
  //         }else {
  //           message.error(`เพิ่มไม่สำเร็จ ${data.error_message}`);
  //         }
  //       },
  //       onError: () => {
  //         message.error("เพิ่มไม่สำเร็จ");
  //       },
  //     }
  //   );
  // }
  
  return (
    <>
    <FormWrapper>
        <FormItemWrapper>
            <HeadWrapper>
            <Typography.Text 
                style={{
                  fontWeight: 600,
                  whiteSpace: "nowrap"
                }}
                underline >กำหนดประเภทบัญชีรับโอน เฉพาะลูกค้า</Typography.Text>
              <ButtonWrapper>
                <StyledButton type="primary" onClick={showDrawer} ><PlusOutlined /> เพิ่มประเภทบัญชีรับโอนเฉพาะ</StyledButton>
              </ButtonWrapper>

            </HeadWrapper>
           
            {retailBankTypeData?.data && retailBankTypeData.data.length > 0 ? (
                retailBankTypeData?.data.map((item) => (
                  <Row style={{ backgroundColor: "#EFEFEFEF" }}>
                    <TypeItemsCard key={item.bank_type_id} data={item} onDeleteData={onDeleteData} />
                  </Row>
                ))
              ) : (
              <Col span={12}>
                <Alert
                  message="ไม่มีกำหนดประเภทบัญชีรับโอนเฉพาะ"
                  // description="ลูกค้า/ตัวแทน ไม่มีข้อมูลค่าจัดส่ง"
                  type="warning"
                />                
              </Col>
              )}

              {/* {agentBankData?.data && agentBankData.data.length > 0 ? (
                agentBankData?.data.map((item) => (
                  <Row style={{ backgroundColor: "#EFEFEFEF" }}>
                    <BankingItemsCard key={item.bank_id} data={item} onDeleteData={onDeleteData} />
                  </Row>
                ))
              ) : (
              <Col span={12}>
                <Alert
                  message="ไม่มีกำหนดประเภทบัญชีรับโอนเฉพาะ"
                  // description="ลูกค้า/ตัวแทน ไม่มีข้อมูลค่าจัดส่ง"
                  type="warning"
                />                
              </Col>
              )} */}

        </FormItemWrapper>
    </FormWrapper>
    {/* <Modal
        title="กำหนดบัญชีรับโอนเฉพาะ"
        open={open}
        maskClosable={false}
        // footer={null}
        onCancel={onClose}
        // width={1000}
        // style={{ top: 20 }}
        onOk={() => {
          form.submit();
        }}  
      >
        <Form form={form} {...formItemLayout} onFinish={onFinish}>
          <BankingConfigForm form={form}/>
        </Form>
      </Modal> */}
      <Modal
        title="กำหนดประเภทบัญชีรับโอนเฉพาะ"
        open={open}
        maskClosable={false}
        onCancel={onClose}
        onOk={() => {
          form.submit();
        }}  
      >
        <Form form={form} {...formItemLayout} onFinish={onFinish}>
          <TypeConfigForm form={form}/>
        </Form>
      </Modal>
    </>
  );
};

export default MainCreateBankingRetail;


const HeadWrapper = styled.div`
  display: flex;
  flex-direction: row;
  padding: 0px 10px 0px 10px;
`;

const FormWrapper = styled.div`
  width: 100%;
  height: 100%;
  background-color: #ffffffff;
  
`;

const FormItemWrapper = styled.div`
  width: 100%;
  height: 100%;
  padding: 10px 0px 10px 0px;
  border-radius: 10px;
`;

const StyledButton = styled(Button)`
margin-right: 5px;
`;

const ButtonWrapper = styled.div`
display:flex;
justify-content: flex-end;  
width: 100%;
height: 100%;
`;